/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { NavLink } from 'react-router-dom';

// eslint-disable-next-line react/prefer-stateless-function
class RightSidebarMenuItem extends Component {
  render() {
    const oddEvent = match => {
      if (!match) {
        return false;
      }
      // Расскрываем родителя если активный
      // eslint-disable-next-line no-undef
      $(`#panelGroupFilter_c_${this.props.item.id}`).collapse('show');
      return true;
    };

    if (!Object.keys(this.props.item.children).length > 0) {
      return (
        <NavLink
          to={`/help/reference-information/view/${this.props.item.seoUrl}`}
          activeClassName="active"
          className="list-group-item"
        >
          <span className="list-group-item-val text-overflow" title="Активные">
            {this.props.item.title}
          </span>
        </NavLink>
      );
    }
    return (
      <div className="panel panel-default">
        <div
          className="panel-heading"
          role="tab"
          id={`panelGroupFilter_h_${this.props.item.id}`}
        >
          <a
            className="dropdown-toggle dropdown-toggle-collapse collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#panelGroupFilter"
            href={`#panelGroupFilter_c_${this.props.item.id}`}
            aria-expanded="true"
            aria-controls={`panelGroupFilter_c_${this.props.item.id}`}
          >
            {this.props.item.title}
          </a>
        </div>
        <div
          id={`panelGroupFilter_c_${this.props.item.id}`}
          className="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby={`panelGroupFilter_h_${this.props.item.id}`}
          aria-expanded="true"
        >
          <div className="list-group">
            {Object.keys(this.props.item.children).map(index => {
              const child = this.props.item.children[index];
              return (
                <NavLink
                  key={`rightSidebarMenuItemLink${index}`}
                  to={`/help/reference-information/view/${child.seoUrl}`}
                  isActive={oddEvent}
                  activeClassName="active"
                  className="list-group-item"
                >
                  <span
                    className="list-group-item-val text-overflow"
                    title="В работе"
                  >
                    {child.title}
                  </span>
                </NavLink>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

RightSidebarMenuItem.propTypes = {
  item: PropTypes.shape({}).isRequired
};

export default RightSidebarMenuItem;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Help/ReferenceInformation/RightSidebar/RightSidebarMenuItem.js